import { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';

import { selectAppState } from 'store/config/selectors.ts';

import { RegularStorage, StorageKeys } from 'services/mmkv';
import useGetReturnToLauncherParams from 'services/uav/useGetReturnToLauncherParams';
import { logUavAnalytics } from 'services/uav/utils';

export default function ReturnToLauncherListener() {
    const appState = useSelector(selectAppState);
    const prevAppState = useRef(appState);

    const { getReturnToLauncherParams } = useGetReturnToLauncherParams();

    useEffect(() => {
        if (
            (prevAppState.current === 'background' ||
                prevAppState.current === 'inactive') &&
            appState === 'active'
        ) {
            (async () => {
                const thirdAppLaunched = await RegularStorage.getItem(
                    StorageKeys.DEEPLINK_RETURN_TO_LAUNCHER,
                );

                if (thirdAppLaunched) {
                    const thirdAppName = await RegularStorage.getItem(
                        StorageKeys.DEEPLINK_THIRD_PART_APP_NAME,
                    );
                    logUavAnalytics(
                        getReturnToLauncherParams(thirdAppName || undefined),
                    );
                    await RegularStorage.removeItem(
                        StorageKeys.DEEPLINK_RETURN_TO_LAUNCHER,
                    );
                    await RegularStorage.removeItem(
                        StorageKeys.DEEPLINK_THIRD_PART_APP_NAME,
                    );
                }
            })();
        }
    }, [getReturnToLauncherParams, appState]);

    useEffect(() => {
        if (prevAppState.current !== appState) {
            prevAppState.current = appState;
        }
    }, [appState]);

    return null;
}
